'use client';

import { useSession, signOut } from 'next-auth/react';
import Link from 'next/link';
import { AppBar, Toolbar, Button, Box, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';

export default function Navigation() {
  const { data: session, status } = useSession();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <AppBar position="static" className="print-hide">
        <Toolbar>
          <Box sx={{ flexGrow: 1 }}>
            <Button color="inherit" component={Link} href="/">
              Home
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
    );
  }

  if (status === 'loading') {
    return (
      <AppBar position="static" className="print-hide">
        <Toolbar>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
            <CircularProgress color="inherit" size={24} />
          </Box>
        </Toolbar>
      </AppBar>
    );
  }

  return (
    <AppBar position="static" className="print-hide">
      <Toolbar>
        <Box sx={{ flexGrow: 1 }}>
          <Button color="inherit" component={Link} href="/">
            Home
          </Button>
        </Box>
        {session ? (
          <>
            {!session.user?.isSuperAdmin && (
              <Button color="inherit" component={Link} href="/profile">
                Profile
              </Button>
            )}
            {session.user?.isAdmin && (
              <Button color="inherit" component={Link} href="/admin">
                Admin
              </Button>
            )}
            {session.user?.isSuperAdmin && (
              <Button color="inherit" component={Link} href="/superadmin">
                Super Admin
              </Button>
            )}
            <Button color="inherit" onClick={() => signOut()}>
              Sign Out
            </Button>
          </>
        ) : (
          <>
            <Button color="inherit" component={Link} href="/auth/signin">
              Sign In
            </Button>
            <Button color="inherit" component={Link} href="/auth/signup">
              Sign Up
            </Button>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
} 